/**
 * Inline stroke icons for the department pages, drawn to match the sidebar's
 * set (24px viewBox, currentColor, stroke-width 2). Decorative: the text
 * beside each icon carries the meaning, so every one is aria-hidden.
 */
const base = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': 'true',
  focusable: 'false',
};

export function CloseIcon() {
  return <svg {...base}><path d="M18 6L6 18M6 6l12 12" /></svg>;
}

export function CheckIcon() {
  return <svg {...base}><path d="M20 6L9 17l-5-5" /></svg>;
}

export function MinusIcon() {
  return <svg {...base}><path d="M5 12h14" /></svg>;
}

export function ArrowRightIcon() {
  return <svg {...base}><path d="M5 12h14M13 6l6 6-6 6" /></svg>;
}
